var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.showNavbar),expression:"$store.state.showNavbar"}],ref:"navbarRef",on:{"changeConnect":_vm.handleIsConnected}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }